import script from "./DpaPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DpaPreview.vue?vue&type=script&setup=true&lang=js"

import "./DpaPreview.vue?vue&type=style&index=0&id=8b89bc40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b89bc40"]])

export default __exports__